type ConsentCheckerBatchType = 'default' | 'enhanced'

export function createConsentAnalysisScenario(type: ConsentCheckerBatchType, data: any) {

  const baseAudit = {
    userDefinedNetwork: data.userDefinedNetwork,
    link: data.link,
    cookieName: data.cookieName,
    cookieType: data.cookieType,
    customAni: data.customAni,
    customMasterTag: data.customNetwork,
    countryCode: data.countryCode,
  }

   // standard
   const standard = {
    ...baseAudit,
    userDefinedMerchant:  'Affiliate > consent > Refresh',
    tagA:                 'Affiliate> consent > Refresh',
  }

  // skip consent
  const skipConsent = {
    ...baseAudit,
    userDefinedMerchant:  'Affiliate> skip > Refresh',
    tagA:                 'Affiliate> skip > Refresh', 
    skipConsent:          true,
  }

  // refresh affiliate link
  const refreshAffiliateHome = {
    ...baseAudit,
    userDefinedMerchant:  'Affiliate > consent > Navigate',
    tagA:                 'Affiliate > consent > Navigate',
    postAlpURL:           data.advertiserHome,
  }

  // affiliate skip affiliate
  const affiliateSkipHome = {
    ...baseAudit,
    userDefinedMerchant:  'Affiliate > skip > Navigate',
    tagA:                 'Affiliate > skip > Navigate',
    link:                 data.link,
    skipConsent:          true,
    postAlpURL:           data.advertiserHome,
  }



  // Generate the correct scenario

  function createScenario(batchLinks: any[]): any[] {
    return batchLinks.map((link, i) => ({
      ...link,
      userDefinedMerchant: `${i + 1}. ${link.userDefinedMerchant}`,
    }))
  }

  if (type === 'default') {
    return createScenario([
      standard,
      refreshAffiliateHome
    ])
  }
  else if (type === 'enhanced') {
    return createScenario([
      standard,
      skipConsent,
      refreshAffiliateHome,
      affiliateSkipHome
    ])
  }
    throw new Error(`Unexpected tech publisher batch type: ${type}`)
}